import React from "react";
import "./Widgets.css";
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterTweetEmbed,
} from "react-twitter-embed";
import SearchIcon from "@mui/icons-material/Search";

function Widgets() {
  return (
    <div className="widgets">
      <div className="widgets__input">
        <SearchIcon className="widgets__SearchIcon" />
        <input placeholder="Search Twitter" type="text" />
      </div>
      <div className="widgets__container">
        <h2>What's happening?</h2>

        <TwitterTweetEmbed tweetId={"1546600970737618947"} />

        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="NASA"
          options={{ height: 400 }}
        />

        <TwitterShareButton
          url={"https://facebook.com/NASA"}
          options={{ text: "#reactjs is awesome", via: "NASA" }}
        />
      </div>
    </div>
  );
}

export default Widgets;
